"use strict";

exports.__esModule = true;
exports.legacyToBookingsSettings = void 0;
var _types = require("@wix/ambassador-bookings-v2-bookings-settings/types");
var _businessInfo = require("./businessInfo");
var _bookingsUouTypes = require("@wix/bookings-uou-types");
const legacyToBookingsSettings = legacy => {
  const info = (0, _businessInfo.getBusinessInfo)(legacy);
  const clientCanChangeTimezone = (0, _businessInfo.canClientChangeTimezone)(legacy);
  const defaultTimezone = (0, _businessInfo.getPropertyValue)(legacy, _businessInfo.BusinessPropertyName.DEFAULT_TIMEZONE) || _bookingsUouTypes.TimezoneType.BUSINESS;
  return {
    displayTimeZone: {
      basedOn: defaultTimezone === _bookingsUouTypes.TimezoneType.BUSINESS ? _types.BasedOn == null ? void 0 : _types.BasedOn.BUSINESS_TIME_ZONE : _types.BasedOn == null ? void 0 : _types.BasedOn.CUSTOMER_TIME_ZONE,
      customerCanChange: clientCanChangeTimezone
    },
    siteProperties: {
      locale: {
        languageCode: (info == null ? void 0 : info.language) ?? '',
        country: (info == null ? void 0 : info.countryCode) ?? ''
      },
      language: (info == null ? void 0 : info.language) ?? '',
      timeZone: (info == null ? void 0 : info.timeZone) ?? '',
      email: (info == null ? void 0 : info.email) ?? '',
      phone: (info == null ? void 0 : info.phone) ?? '',
      paymentCurrency: (info == null ? void 0 : info.currency) ?? '',
      address: {
        googleFormattedAddress: (info == null ? void 0 : info.googleFormattedAddress) ?? ''
      },
      businessName: (info == null ? void 0 : info.name) ?? ''
    }
  };
};
exports.legacyToBookingsSettings = legacyToBookingsSettings;
//# sourceMappingURL=legacyToSettingsBusinessInfo.js.map